import React from 'react'
import ArrowUpSortIcon from "../../../assets/icons/ArrowUpSortIcon";
import ArrowDownSortIcon from "../../../assets/icons/ArrowDownSortIcon";
import ChevronsUpDownIcon from "../../../assets/icons/ChevronsUpDownIcon";
import "./styles.css"

const TableHeaderSort = ({isActive, direction, style = {}}) => {
    return (
        <span className="table-header-sort-icon" style={style} aria-hidden="true">
            {isActive ? (
                direction === 'asc' ? (
                    <ArrowUpSortIcon width="18" height="18"/>
                ) : (
                    <ArrowDownSortIcon width="18" height="18"/>
                )
            ) : (
                <ChevronsUpDownIcon className="chevron-icon" width="16" height="16"/>
            )}
        </span>
    )
}

export default TableHeaderSort



// WEBPACK FOOTER //
// ./src/components-new/table/TableHeaderSort/index.jsx